import { MenuGroupInterface } from './menu-group.interface';
import { MenuCollapseInterface } from './menu-collapse.interface';
import { MenuIntemInterface } from './menu-intem.interface';

export class AppNavigationModel {

    public model: (MenuGroupInterface | MenuCollapseInterface | MenuIntemInterface)[] | undefined;

    constructor(rol?: string, rolLabel?: string) {
        rolLabel = rolLabel ?? '';

        if (rol == 'tenant') {
            this.model = [
                {
                    id: 'type',
                    title: rolLabel.toLocaleUpperCase(),
                    type: 'group',
                    children: [
                        {
                            id   : 'inicio',
                            title: 'Inicio',
                            type : 'item',
                            url  : 'propiedades',
                            icon: 'home',
                            iconCustom: false
                        },
                        {
                            id   : 'my-rents',
                            title: 'Mi renta',
                            type : 'item',
                            url  : 'rentas',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'netta-score',
                            title: 'netta Score',
                            type : 'item',
                            url  : 'netta-score',
                            icon: 'add_chart',
                            iconCustom: false
                        },
                        {
                            id   : 'maintenance',
                            title: 'Mantenimiento',
                            type : 'item',
                            url  : 'mantenimiento',
                            icon: 'engineering',
                            iconCustom: false
                        },
                        {
                            id   : 'my-account',
                            title: 'Mi cuenta',
                            type : 'collapse',
                            icon: 'person',
                            iconCustom: false,
                            children: [
                                {
                                    id   : 'details',
                                    title: 'Detalles de la cuenta',
                                    type : 'item',
                                    url  : 'account'
                                },
                                {
                                    id   : 'method',
                                    title: 'Métodos de pago',
                                    type : 'item',
                                    url  : 'metodos-de-pago'
                                },
                                {
                                    id   : 'terminos',
                                    title: 'Términos y condiciones',
                                    type : 'item',
                                    url  : 'terminos'
                                },
                                {
                                    id   : 'politicas',
                                    title: 'Politicas de privacidad',
                                    type : 'item',
                                    url  : 'politicas'
                                },
                                {
                                    id   : 'help',
                                    title: 'Ayuda',
                                    type : 'item',
                                    url  : 'ayuda',
                                },
                                {
                                    id   : 'faq',
                                    title: 'FAQ´s',
                                    type : 'item',
                                    url  : 'faq',
                                }
                            ]
                        },
                        {
                            id   : 'logout',
                            title: 'Cerrar sesión',
                            type : 'item',
                            icon: 'power_settings_new',
                            function: () => AppNavigationModel.clearCache()
                        }
                    ]
                }
            ];
        } else if (rol == 'owner' || rol == 'both') {
            this.model = [
                {
                    id: 'type',
                    title: rolLabel.toLocaleUpperCase(),
                    type: 'group',
                    children: [
                        {
                            id   : 'my-properties',
                            title: 'Mis propiedades',
                            type : 'item',
                            url  : 'propiedades',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'my-payments',
                            title: 'Mis pagos',
                            type : 'item',
                            url  : 'mis-pagos',
                            icon: 'local_atm',
                            iconCustom: false
                        },
                        {
                            id   : 'advances',
                            title: 'Adelantos',
                            type : 'item',
                            url  : 'adelantos',
                            icon: 'local_atm',
                            iconCustom: false
                        },
                        {
                            id   : 'maintenance',
                            title: 'Mantenimiento',
                            type : 'item',
                            url  : 'mantenimiento',
                            icon: 'engineering',
                            iconCustom: false
                        },
                        {
                            id   : 'my-account',
                            title: 'Mi cuenta',
                            type : 'collapse',
                            icon: 'person',
                            iconCustom: false,
                            children: [
                                {
                                    id   : 'details',
                                    title: 'Detalles de la cuenta',
                                    type : 'item',
                                    url  : 'account'
                                },
                                {
                                    id   : 'terminos',
                                    title: 'Términos y condiciones',
                                    type : 'item',
                                    url  : 'terminos'
                                },
                                {
                                    id   : 'privacity',
                                    title: 'Aviso de privacidad',
                                    type : 'item',
                                    url  : 'politicas'
                                },
                                {
                                    id   : 'help',
                                    title: 'Ayuda',
                                    type : 'item',
                                    url  : 'ayuda',
                                },
                                {
                                    id   : 'faq',
                                    title: 'FAQ´s',
                                    type : 'item',
                                    url  : 'faq',
                                }
                            ]
                        },
                        {
                            id   : 'logout',
                            title: 'Cerrar sesión',
                            type : 'item',
                            icon: 'power_settings_new',
                            function: () => AppNavigationModel.clearCache()
                        }
                    ]
                }
            ];
        } else if (rol == 'admin') {
            this.model = [
                {
                    id: 'type',
                    title: rolLabel.toLocaleUpperCase(),
                    type: 'group',
                    children: [
                        {
                            id   : 'details',
                            title: 'Mi cuenta',
                            type : 'item',
                            url  : 'account',
                            icon : 'person'
                        },
                        {
                            id   : 'adduser',
                            title: 'Agregar usuario',
                            type : 'item',
                            url  : 'usuarios/agregar',
                            icon: 'group_add',
                            iconCustom: false
                        },
                        {
                            id   : 'listuser',
                            title: 'Lista de usuarios',
                            type : 'item',
                            url  : 'usuarios',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'properties',
                            title: 'Listado de propiedades',
                            type : 'item',
                            url  : 'propiedades/admin',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'advances',
                            title: 'Lista de adelantos',
                            type : 'item',
                            url  : 'adelantos',
                            icon: 'local_atm',
                            iconCustom: false
                        },
                        {
                            id   : 'cupones',
                            title: 'Lista de cupones',
                            type : 'item',
                            url  : 'cupones',
                            icon : 'confirmation_number',
                            iconCustom: false
                        },
                        {
                            id   : 'payments',
                            title: 'Listado de pagos',
                            type : 'item',
                            url  : 'pagos',
                            icon: 'request_quote',
                            iconCustom: false
                        },
                        {
                            id   : 'dashboard',
                            title: 'Dashboard',
                            type : 'item',
                            url  : 'dashboard',
                            icon: 'important_devices',
                            iconCustom: false
                        },
                        {
                            id   : 'customlayout',
                            title: 'Custom Layout',
                            type : 'item',
                            url  : 'custom-layout',
                            icon: 'dashboard',
                            iconCustom: false
                        },
                        {
                            id   : 'logout',
                            title: 'Cerrar sesión',
                            type : 'item',
                            icon: 'power_settings_new',
                            function: () => AppNavigationModel.clearCache()
                        }
                    ]
                }
            ];
        } else if (rol === 'marketing') {
            this.model = [
                {
                    id: 'type',
                    title: rolLabel.toLocaleLowerCase(),
                    type: 'group',
                    children: [
                        {
                            id   : 'customlayout',
                            title: 'Custom Layout',
                            type : 'item',
                            url  : 'custom-layout',
                            icon: 'dashboard',
                            iconCustom: false
                        },
                        {
                            id   : 'logout',
                            title: 'Cerrar sesión',
                            type : 'item',
                            icon: 'power_settings_new',
                            function: () => AppNavigationModel.clearCache()
                        }
                    ]
                }
            ];
        }
    }

    public static getItem(rol?: string, rolLabel?: string): (MenuGroupInterface | MenuCollapseInterface | MenuIntemInterface)[] {
        rolLabel = rolLabel ?? '';

        if (rol == 'tenant') {
            return [
                {
                    id: 'type',
                    title: rolLabel.toLocaleUpperCase(),
                    type: 'group',
                    children: [
                        {
                            id   : 'inicio',
                            title: 'Inicio',
                            type : 'item',
                            url  : 'propiedades',
                            icon: 'home',
                            iconCustom: false
                        },
                        {
                            id   : 'my-rents',
                            title: 'Mi renta',
                            type : 'item',
                            url  : 'rentas',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'netta-score',
                            title: 'netta Score',
                            type : 'item',
                            url  : 'netta-score',
                            icon: 'add_chart',
                            iconCustom: false
                        },
                        {
                            id   : 'maintenance',
                            title: 'Mantenimiento',
                            type : 'item',
                            url  : 'mantenimiento',
                            icon: 'engineering',
                            iconCustom: false
                        },
                        {
                            id   : 'my-account',
                            title: 'Mi cuenta',
                            type : 'collapse',
                            icon: 'person',
                            iconCustom: false,
                            children: [
                                {
                                    id   : 'details',
                                    title: 'Detalles de la cuenta',
                                    type : 'item',
                                    url  : 'account'
                                },
                                {
                                    id   : 'method',
                                    title: 'Métodos de pago',
                                    type : 'item',
                                    url  : 'metodos-de-pago'
                                },
                                {
                                    id   : 'terminos',
                                    title: 'Términos y condiciones',
                                    type : 'item',
                                    url  : 'terminos'
                                },
                                {
                                    id   : 'politicas',
                                    title: 'Politicas de privacidad',
                                    type : 'item',
                                    url  : 'politicas'
                                },
                                {
                                    id   : 'help',
                                    title: 'Ayuda',
                                    type : 'item',
                                    url  : 'ayuda',
                                },
                                {
                                    id   : 'faq',
                                    title: 'FAQ´s',
                                    type : 'item',
                                    url  : 'faq',
                                }
                            ]
                        },
                        {
                            id   : 'logout',
                            title: 'Cerrar sesión',
                            type : 'item',
                            icon: 'power_settings_new',
                            function: () => AppNavigationModel.clearCache()
                        }
                    ]
                }
            ];
        } else if (rol == 'owner' || rol == 'both') {
            return [
                {
                    id: 'type',
                    title: rolLabel.toLocaleUpperCase(),
                    type: 'group',
                    children: [
                        {
                            id   : 'my-properties',
                            title: 'Mis propiedades',
                            type : 'item',
                            url  : 'propiedades',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'my-payments',
                            title: 'Mis pagos',
                            type : 'item',
                            url  : 'mis-pagos',
                            icon: 'local_atm',
                            iconCustom: false
                        },
                        {
                            id   : 'advances',
                            title: 'Adelantos',
                            type : 'item',
                            url  : 'adelantos',
                            icon: 'local_atm',
                            iconCustom: false
                        },
                        {
                            id   : 'maintenance',
                            title: 'Mantenimiento',
                            type : 'item',
                            url  : 'mantenimiento',
                            icon: 'engineering',
                            iconCustom: false
                        },
                        {
                            id   : 'my-account',
                            title: 'Mi cuenta',
                            type : 'collapse',
                            icon: 'person',
                            iconCustom: false,
                            children: [
                                {
                                    id   : 'details',
                                    title: 'Detalles de la cuenta',
                                    type : 'item',
                                    url  : 'account'
                                },
                                {
                                    id   : 'terminos',
                                    title: 'Términos y condiciones',
                                    type : 'item',
                                    url  : 'terminos'
                                },
                                {
                                    id   : 'privacity',
                                    title: 'Aviso de privacidad',
                                    type : 'item',
                                    url  : 'politicas'
                                },
                                {
                                    id   : 'help',
                                    title: 'Ayuda',
                                    type : 'item',
                                    url  : 'ayuda',
                                },
                                {
                                    id   : 'faq',
                                    title: 'FAQ´s',
                                    type : 'item',
                                    url  : 'faq',
                                }
                            ]
                        },
                        {
                            id   : 'logout',
                            title: 'Cerrar sesión',
                            type : 'item',
                            icon: 'power_settings_new',
                            function: () => AppNavigationModel.clearCache()
                        }
                    ]
                }
            ];
        } else if (rol == 'admin') {
            return [
                {
                    id: 'type',
                    title: rolLabel.toLocaleUpperCase(),
                    type: 'group',
                    children: [
                        {
                            id   : 'adduser',
                            title: 'Agregar usuario',
                            type : 'item',
                            url  : 'usuarios/agregar',
                            icon: 'group_add',
                            iconCustom: false
                        },
                        {
                            id   : 'listuser',
                            title: 'Lista de usuarios',
                            type : 'item',
                            url  : 'usuarios',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'properties',
                            title: 'Listado de propiedades',
                            type : 'item',
                            url  : 'propiedades/admin',
                            icon: 'list_alt',
                            iconCustom: false
                        },
                        {
                            id   : 'advances',
                            title: 'Lista de adelantos',
                            type : 'item',
                            url  : 'adelantos',
                            icon: 'local_atm',
                            iconCustom: false
                        },
                        {
                            id   : 'payments',
                            title: 'Listado de pagos',
                            type : 'item',
                            url  : 'pagos',
                            icon: 'request_quote',
                            iconCustom: false
                        },
                        {
                            id   : 'dashboard',
                            title: 'Dashboard',
                            type : 'item',
                            url  : 'dashboard',
                            icon: 'important_devices',
                            iconCustom: false
                        },
                        {
                            id   : 'logout',
                            title: 'Cerrar sesión',
                            type : 'item',
                            icon: 'power_settings_new',
                            function: () => AppNavigationModel.clearCache()
                        }
                    ]
                }
            ];
        }

        return [];
    }

    public static clearCache(): void {
        var tokenFirebase = localStorage.getItem('token-firebase') ?? '';
        localStorage.clear();
        localStorage.setItem('token-firebase', tokenFirebase);
        window.location.href = 'https://netta.mx/';
    }
}
